
export function hasEditPermission(currentUrl: string, userGroups: string[]){

    return (
        (userGroups.includes('flytsuite.live.passenger.edit') && currentUrl.startsWith('/app/passengers')) ||
        (userGroups.includes('flytsuite.schedule.passenger') && (
            currentUrl.startsWith('/app/scheduling/schedule') ||
            currentUrl.startsWith('/app/scheduling/quickschedule') ||
            currentUrl.startsWith('/app/scheduling/groups')
        )) ||
        (userGroups.includes('flytsuite.schedule.flight') && currentUrl.startsWith('/app/scheduling/flight'))
    )
}